<template>
  <div class="secondary-page-container">
    <div class="secondary-nav" v-if="pages.length > 0">
      <div class="nav-tabs">
        <div
          v-for="page in pages"
          :key="page.id"
          :class="['tab-item', { active: activePageId === page.id }]"
          @click="switchPage(page.id)"
        >
          {{ page.title }}
          <i
            class="el-icon-close close-icon"
            @click.stop="closePage(page.id)"
          ></i>
        </div>
      </div>
    </div>

    <div class="secondary-content">
      <keep-alive>
        <component
          ref="activeComponentRef"
          :is="activeComponent"
          v-if="activeComponent"
          v-bind:info="activeProps"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    activeComponent(newVal, oldVal) {
      // 这里仅针对个人中心的组件，如果有其他组件要这样使用建议使用同样的 data 名
      this.$nextTick(() => {
        if (this.$refs.activeComponentRef) {
          const page = this.pages.find((p) => p.id === this.activePageId);
          this.$refs.activeComponentRef.selectedIndex =
            page?.selectedIndex || 0;
          if (page.selectedIndex) {
            this.$refs.activeComponentRef.currentComponent =
              page?.component || null;
          } else {
            this.$refs.activeComponentRef.currentComponent =
              this.$refs.activeComponentRef.navBarList[0].component;
          }
        }
      });
    },
  },
  computed: {
    pages() {
      return this.$store.state.page.pages;
    },
    activePageId() {
      return this.$store.state.page.activePageId;
    },
    activeComponent() {
      const page = this.pages.find((p) => p.id === this.activePageId);
      if (page && page.parentId) {
        const parentPage = this.pages.find(
          (p) => p.id === page.parentId
        ).component;
        return parentPage;
      }
      return page ? page.component : null;
    },
    activeProps() {
      const page = this.pages.find((p) => p.id === this.activePageId);
      return page ? page.props : {};
    },
  },
  methods: {
    switchPage(id) {
      this.$store.dispatch("page/switchPage", id);
    },
    closePage(id) {
      this.$store.dispatch("page/closePage", id);
    },
  },
};
</script>

<style scoped>
.secondary-page-container {
  width: 100%;
  height: calc(100% - 45px);
  display: flex;
  flex-direction: column;
  padding: 80px 3% 20px 3%;
}

.secondary-nav {
  /* border-bottom: 1px solid #e6e6e6; */
  /* padding: 0 10px; */
  margin-bottom: 15px;
}

.nav-tabs {
  display: flex;
}

.tab-item {
  position: relative;
  padding: 8px 30px 8px 15px;
  margin-right: 5px;
  cursor: pointer;
  border: 1px solid #e6e6e6;
  /* border-bottom: none; */
  border-radius: 4px 4px 0 0;
  background: #fff;
  white-space: nowrap;
}

.tab-item.active {
  background: #f5f5f5;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: -1px;
  z-index: 1;
}

.close-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #999;
}

.close-icon:hover {
  color: #333;
}

.secondary-content {
  flex: 1;
  /* padding: 15px; */
  /* background: #fff; */
  /* overflow: auto; */
}
</style>
